export const IDLE_SESSION_CONFIG = {
  /**
   * 60 minutes in milliseconds.
   * Session will be terminated if no API requests are made within this period.
   */
  IDLE_TIMEOUT_MS: 60 * 60 * 1000,

  /**
   * 2 minutes in milliseconds.
   * Warning modal will show this many ms before timeout.
   */
  WARNING_BEFORE_TIMEOUT_MS: 2 * 60 * 1000,

  /**
   * How often to check the idle status (in milliseconds).
   */
  CHECK_INTERVAL_MS: 1000,

  /**
   * LocalStorage key for cross-tab synchronization.
   */
  STORAGE_KEY: 'ltdan_last_activity',

  /**
   * BroadcastChannel name for cross-tab communication.
   */
  BROADCAST_CHANNEL: 'ltdan_idle_session',

  /**
   * Error code returned by backend when session is idle-timed-out.
   */
  ERROR_CODE: 'idleTimeout',
} as const;
